import {Component} from '@angular/core';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {Platform} from '@ionic/angular';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [StatusBar],
})
export class AppComponent {

    /**
     * Constructor
     */
    constructor(
        private _statusBar: StatusBar,
        private _platform: Platform
    ) {
        this._platform.ready().then(() => {

            // garante que não invade a status bar
            this._statusBar.overlaysWebView(true);

            // set status color
            this._statusBar.styleDefault();

        });
    }
}
